export default __webpack_public_path__ + "static/media/property_926.ca29e2f5.png";